import React from "react";
import {
  Button, Card, CardContent, Chip,
  Grid2 as Grid, styled, Typography,
} from "@mui/material";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";

const ColorButton = styled(Button)(({ theme }) => ({
  color: "#fff",
  backgroundColor: "#7395f8",
  "&:hover": {
    backgroundColor: "#6185f2",
  },
}));

const STATUS_COLOR = {
  pendiente: "warning",
  aprobado: "success",
}

const STATUS_LABEL = {
  pendiente: "Pendiente de validación",
  aprobado: "Aprobado"
}

const COLOR = {
  pendiente: "#9F7729",
  aprobado: "#C0F4EB"
}

const ClientCard = ({
  userClient,
  handleEdit,
  handleDelete,
  handleAccept,
}) => {

  return (
    <Card
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "column",
      }}
    >
      <CardContent>
        <Grid container spacing={2}>
          <Grid size={12}>
            <Grid container sx={{ alignItems: "center" }}>
              <Grid
                size={{ xs: 12, md: 7, lg: 8 }}
                sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}
              >
                <Typography variant="h6" color="primary">
                  <small>Información Personal</small>
                </Typography>
                <Chip
                  label={STATUS_LABEL[userClient.status]}
                  color={STATUS_COLOR[userClient.status]}
                  size="small"
                  sx={{ marginLeft: 3, color: COLOR[userClient.status], fontSize: "10px" }}
                />
              </Grid>
              <Grid
                size={{ xs: 12, md: 5, lg: 4 }}
                sx={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Typography variant="body2">
                  <small>
                    <span style={{ color: "#737791" }}>ID de cliente</span> {userClient._id}
                  </small>
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid size={{ xs: 12, md: 6, lg: 8 }}>
            <Grid container spacing={2}>
              <Grid size={{ xs: 12, md: 6, lg: 6 }}>
                <Typography variant="body2" color="#737791">
                  <small>Razón Social</small>
                </Typography>
                <Typography variant="body2">
                  {userClient.razon_social}
                </Typography>
              </Grid>
              <Grid size={{ xs: 12, md: 6, lg: 6 }}>
                <Typography variant="body2" color="#737791">
                  <small>RFC</small>
                </Typography>
                <Typography variant="body2">
                  {userClient.rfc}
                </Typography>
              </Grid>
              <Grid size={{ xs: 12, md: 6, lg: 6 }}>
                <Typography variant="body2" color="#737791">
                  <small>Nombre</small>
                </Typography>
                <Typography variant="body2">
                  {userClient.name}
                </Typography>
              </Grid>
              <Grid size={{ xs: 12, md: 12, lg: 6 }}>
                <Typography variant="body2" color="#737791">
                  <small>Correo</small>
                </Typography>
                <Typography variant="body2" sx={{ wordBreak: "break-word" }}>
                  {userClient.email}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid size={{ xs: 12, md: 6, lg: 4 }}>
            <Grid container spacing={2} sx={{ justifyContent: "flex-end" }} >
              {userClient.status === "pendiente" &&
                <Grid size={{ xs: 12, md: 6, lg: 4 }}>
                  <Button
                    color="error"
                    variant="contained"
                    size="small"
                    onClick={() => handleDelete(userClient._id)}
                    endIcon={<HighlightOffIcon />}
                    sx={{ color: "#FFF", minWidth: "auto", marginRight: "0.5rem", fontSize: "14px", textTransform: "none" }}
                    fullWidth
                  >
                    Rechazar
                  </Button>
                </Grid>
              }
              {handleEdit && (
                <Grid size={{ xs: 12, md: 6, lg: 4 }}>
                  <ColorButton
                    variant="contained"
                    size="small"
                    onClick={() => handleEdit(userClient._id)}
                    endIcon={<DriveFileRenameOutlineIcon />}
                    sx={{ color: "#FFF", minWidth: "auto", marginRight: "0.5rem", fontSize: "14px", textTransform: "none" }}
                    fullWidth
                  >
                    Editar
                  </ColorButton>
                </Grid>
              )}
              {userClient.status === "pendiente" &&
                <Grid size={{ xs: 12, md: 6, lg: 4 }}>
                  <Button
                    color="primary"
                    variant="contained"
                    size="small"
                    onClick={() => handleAccept(userClient._id)}
                    endIcon={<ControlPointIcon />}
                    sx={{ color: "#FFF", minWidth: "auto", marginRight: "0.5rem", fontSize: "14px", textTransform: "none" }}
                    fullWidth
                  >
                    Aceptar
                  </Button>
                </Grid>
              }
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}

export default ClientCard;
